<template>
  <div class="time-grid">
    <label>{{ $t('insights.ui.norm.time.label') }}</label><br/>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text" id="time-hours-dropdown">
          <select v-model="config.normPerDayInTime.unit"
                  @change="emitConfig"
                  class=form-control id="">
            <option value="H">{{$t('insights.ui.norm.unit.hour') }}</option>
            <option value="M">{{$t('insights.ui.norm.unit.minutes') }}</option>
          </select>
        </div>
      </div>
      <input aria-describedby="basic-addon1" type="number" id="time-hours" class="form-control" @change="emitConfig" v-model="config.normPerDayInTime.value">
    </div>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";

export default {
  mixins: [generalMethods],
  name: "WeekSelect",
  props: ['editing', 'currentConfig'],
  data() {
  },
  computed: {

  },
  methods: {

  },
  created(){
    this.config = this.currentConfig;
    if (!this.config.normPerDayInTime) {
      this.config.normPerDayInTime = {
        unit: 'H',
        value: 0
      };
    }
  }

}
</script>

<style scoped>

.input-group-text {
  width: 12rem;
  background-color: #ebebeb;
}

.input-group-text > select {
  margin-top: -1px;
  background-color: #ebebeb;
  margin-bottom: -3px;
}

</style>